const SESSION_DAYS = 5;
const SESSION_VERSION = '2';
const MS_PER_DAY = 24 * 60 * 60 * 1000;

const KEYS = {
  loggedIn: 'loggedIn',
  userType: 'userType',
  authToken: 'authToken',
  loginAt: 'authLoginAt',
  expiresAt: 'authExpiresAt',
  sessionVersion: 'authSessionVersion',
  rememberedEmail: 'rememberedEmail',
};

export function setAuthSession(user, token) {
  const now = Date.now();
  const expiresAt = now + SESSION_DAYS * MS_PER_DAY;

  localStorage.setItem(KEYS.loggedIn, 'true');
  localStorage.setItem(KEYS.userType, JSON.stringify(user));
  if (token) {
    localStorage.setItem(KEYS.authToken, token);
  }
  localStorage.setItem(KEYS.loginAt, String(now));
  localStorage.setItem(KEYS.expiresAt, String(expiresAt));
  localStorage.setItem(KEYS.sessionVersion, SESSION_VERSION);
}

export function clearAuthSession({ keepRememberedEmail = true } = {}) {
  const remembered = keepRememberedEmail
    ? localStorage.getItem(KEYS.rememberedEmail)
    : null;

  localStorage.removeItem(KEYS.loggedIn);
  localStorage.removeItem(KEYS.userType);
  localStorage.removeItem(KEYS.authToken);
  localStorage.removeItem(KEYS.loginAt);
  localStorage.removeItem(KEYS.expiresAt);
  localStorage.removeItem(KEYS.sessionVersion);

  if (!keepRememberedEmail) {
    localStorage.removeItem(KEYS.rememberedEmail);
  } else if (remembered) {
    localStorage.setItem(KEYS.rememberedEmail, remembered);
  }
}

export function getAuthToken() {
  return localStorage.getItem(KEYS.authToken) || '';
}

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem(KEYS.userType);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isSuperAdmin() {
  return getCurrentUser()?.role === 'superadmin';
}

export function isPanelAdmin() {
  const role = getCurrentUser()?.role;
  return role === 'superadmin' || role === 'admin';
}

export function isAuthSessionValid() {
  if (localStorage.getItem(KEYS.loggedIn) !== 'true') {
    return false;
  }

  const version = localStorage.getItem(KEYS.sessionVersion);
  const expiresAt = Number(localStorage.getItem(KEYS.expiresAt));

  if (version !== SESSION_VERSION || !expiresAt || Number.isNaN(expiresAt)) {
    clearAuthSession();
    return false;
  }

  if (Date.now() >= expiresAt) {
    clearAuthSession();
    return false;
  }

  return true;
}

export function getSessionExpiresAt() {
  return Number(localStorage.getItem(KEYS.expiresAt)) || 0;
}

export function getSessionDaysRemaining() {
  const expiresAt = getSessionExpiresAt();
  if (!expiresAt) return 0;
  const remainingMs = expiresAt - Date.now();
  if (remainingMs <= 0) return 0;
  return Math.ceil(remainingMs / MS_PER_DAY);
}

export { SESSION_DAYS };
